import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Team } from 'api/models';
import { Action, EventType, ObjectType, TeamSocketData } from 'api/pushes';
import { useTeamWsUpdates } from 'hooks/use-team-ws-updates';
import { add as addTeam, remove as deleteTeam } from 'stores/teams';

export const useDefaultPlaceholderWSUpdates = (): void => {
  const dispatch = useDispatch();

  const handleTeamSocketDelete = useCallback(
    async (socketData: TeamSocketData<Team>) => {
      switch (socketData.action) {
        case Action.Create:
          {
            const newTeam = socketData.data;

            dispatch(addTeam(newTeam));
          }

          break;

        case Action.Delete:
          {
            const deletedTeamId = socketData.data.teamId;

            dispatch(deleteTeam(deletedTeamId));
          }

          break;

        default:
      }
    },
    [dispatch],
  );

  useTeamWsUpdates(
    handleTeamSocketDelete,
    EventType(Action.Delete, ObjectType.Team),
  );

  useTeamWsUpdates(
    handleTeamSocketDelete,
    EventType(Action.Create, ObjectType.Team),
  );
};
